module.exports = __webpack_public_path__ + "static/media/18.76cd56f9.png";